// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QJvL","delete":"styles_delete__2GDFL","update":"styles_update__1om2N","add":"styles_add__2ghjW"};